<template>
    <article>       
        <section class="xbed-sub-title">
            <span>{{title}}</span>
        </section>    
        <section class="xbed-breadcrumb">
            <Breadcrumb>
                <BreadcrumbItem>房间信息</BreadcrumbItem>
                <BreadcrumbItem>{{title}}</BreadcrumbItem>
            </Breadcrumb>
        </section>
        <section style="margin-top:20px;">
            <Form inline>
              <FormItem  label="筛选城市" :label-width="80">	
                  <Select  v-model="formListData.hotCity" @on-change="changeHotCity" style="width:200px">	
                    <Option value="全部" key="0">全部</Option>
                    <Option v-for="item in formListData.hotCitys" :value="item.cname" :key="item.code">{{item.cname}}</Option>														
                  </Select>
              </FormItem>
              <FormItem  label="查询" :label-width="95">
                    <Input  v-model="formListData.searchKey" @on-keyup="changeSearchkey" placeholder="请输入关键字"></Input>   
              </FormItem>
              <Button type="primary"  @click="showAllRoom">按房间添加</Button><span class="text-tips">特别提醒：权重越大的房间在越前面</span>
            </Form>
            <Table stripe :loading = "formListData.loading" height="600" :columns="column" :data="formListData.list"></Table>
              <div style="margin: 10px;overflow: hidden">
                  <Page show-sizer placement="top" :page-size="formListData.pageSize"  :total="formListData.count" :current="formListData.curpage" @on-page-size-change="changePageSize" @on-change="changePage"></Page>
              </div>
        </section>
        <Modal v-model="weight.isShow" :loading=true  @on-ok="submitWeight" title="修改房间排序权重" ref="weightModal" ok-text="提交">
            <Form>
                <FormItem  label="房间id:" :label-width="80">
                    <span>{{weight.roomId}}</span>
                </FormItem>
                <FormItem  label="房间名:" :label-width="80">
                    <span>{{weight.custRoomNo}}</span>
                </FormItem>
                <FormItem  label="房间标题:" :label-width="80">
                    <span>{{weight.custRoomName}}</span>
                </FormItem>
                <FormItem  label="排序权重:" :label-width="80">
                    <Input v-model="weight.sort" number>{{weight.sort}}</Input>
                </FormItem>
            </Form>         
        </Modal>
        <!--全部房间列表houseList  model Start-->
        <Modal v-model="houseList.isShow" :loading="houseList.addRoomLoading"  @on-ok="addSortByRoomIds" title="房间列表" ok-text="提交修改" width=800>
            <Form inline ref="houseListModal" :rules="houseListRules" :model="houseList">            
                <FormItem  label="查询:" :label-width="80">
                    <Input v-model="houseList.searchKey" @on-keyup="houseSearch" placeholder="请输入关键字"></Input>
                </FormItem>
                <FormItem prop="sort" label="排序权重:" :label-width="120">
                    <Input v-model="houseList.sort">{{houseList.sort}}</Input>
                </FormItem>
            </Form>
             
            <Table :columns="houseList.columns" height='550' :loading = "houseList.loading" :data="houseList.list" @on-select-all="allSelect" @on-select="selectOne"   @on-selection-change="selectionChange" ref="houseTable"></Table>
            <div style="margin: 10px;overflow: hidden">
                  <Page show-sizer placement="top" :page-size="houseList.pageSize"  :total="houseList.count" :current="houseList.curpage" @on-page-size-change="houseChangePageSize" @on-change="houseChangePage"></Page>
              </div>
        </Modal>
         <!--全部房间列表houseList  model end-->
    </article>
</template>
<script>
// import Moment from "moment";
import Utils from "@/utils";
// import Config from "@/config";
 import API from "@/api";
export default {    
    created(){  
        this.token = Utils.findFromLocalStorage("vue-token");
        this.username = Utils.findFromLocalStorage("vue-username");
        this.env = Utils.findFromLocalStorage("env", "dev");
        //this.goOnce = true;//查询房间默认只进来一次
        //this.getAllRoomData();
    },
    methods:{
      async getQuerySortList(){//获得设置所有房间数据
        this.formListData.loading = true;
        let resp =  (await API.omsAPI[this.env].php.querySortList({"roomIds":[]}));//.data.data;        
        if(resp.data.retcode == 1){                         
          //this.formListData.list = resp.data.retdata;
          resp.data.retdata.forEach(item=>{
            item.queryString = `${item.roomId+item.city+item.custRoomNo+item.custRoomName+item.roomTypeName}`
          })
          
          this.tempListData =  resp.data.retdata;//暂存数据
          this.tempSecond = resp.data.retdata;//二级存储
          this.keyTemp = resp.data.retdata;
          this.formListData.count = resp.data.retdata.length;
          this.formListData.list = this.toCurPage(this.formListData.curpage,this.tempListData,this.formListData.pageSize);
        }else{
          this.$Notice.config({
            title: resp.data.retmsg
          });
        } 
        this.formListData.loading = false;       
      },
      async queryRoomTagByCname(){          
          let resp =  (await API.omsAPI[this.env].php.queryRoomTagByCname({"cnameWay":"热门城市"}));//.data.data;
          if(resp.data.retcode == 1){
              this.formListData.hotCitys = resp.data.retdata;
          }else{
              this.$Notice.config({
                title: resp.data.retmsg
			});
          }
      },
      changeHotCity(city){//热点城市改变触发
          this.tempListData = this.tempSecond;
          let i=0,len = this.tempListData.length,arr=[];     
          if(city == "全部"){
              this.formListData.list = this.toCurPage(this.formListData.curpage,this.tempSecond,this.formListData.pageSize);//重新赋值
              this.formListData.count = len;
              this.formListData.searchKey = '';//清空查询条件
              return;
          }        
          for(;i<len;i++){
              (this.tempListData[i].city.replace(/^\s+|\s+$/gm,'') ===  city) ? arr.unshift(this.tempListData[i]) : '';
          }           
          this.tempSecond =  this.tempListData;//二级暂存          
          this.tempListData = arr;
          this.keyTemp = this.tempListData;
          this.formListData.list = this.toCurPage(this.formListData.curpage,this.tempListData,this.formListData.pageSize);
          this.formListData.count = this.tempListData.length;
          this.formListData.curpage = 1;
          this.formListData.searchKey = '';//清空查询条件
      },
      isContain(str,substr){//字符串搜索匹配      
        return str.indexOf(substr)>=0; 
      }, 
      
      toCurPage(pageNum,originData,pagesize){//获得当前页的数据 
        let arr = [],i=0,len = originData.length;      
        for(;i<len;i++){
            if((pageNum-1)*pagesize<=i && i<pagesize*pageNum)
            arr.unshift(originData[i]);
        }   
        return arr;
      },
      changePageSize(pagesize){
          this.formListData.pageSize = pagesize;
          this.formListData.curpage = 1;
          this.formListData.list =this.toCurPage(this.formListData.curpage,this.tempListData,this.formListData.pageSize);    
      },
      changePage(pageNum){//点击分页
          this.formListData.curpage = pageNum;
          this.formListData.list = this.toCurPage(this.formListData.curpage,this.tempListData,this.formListData.pageSize);    
      },
      async submitWeight(){//提交权重修改
        let obj={};
        obj.roomId  = this.weight.roomId;
        obj.custRoomNo  = this.weight.custRoomNo;
        obj.custRoomName  = this.weight.custRoomName;
        obj.sort  = this.weight.sort;
        let resp = (await API.omsAPI[this.env].php.editSort(obj));
        if(resp.data.retcode ==1){
            this.$Notice.success({
				title: "修改成功！！"
            });
            this.weight.isShow = false;            
            this.formListData.list[this.dataIndex].sort = obj.sort;//编辑成功此项后跟新权重字段
        }else{
            this.$Notice.error({
				title: resp.data.retmsg
			});
        }
      },
      async delRoom(roomid){//删除房间
          let obj = {};
          obj.roomId = roomid;
          obj.sort = 0;
          let resp = (await API.omsAPI[this.env].php.editSort(obj));
          if(resp.data.retcode ==1){            
            this.$Notice.success({
				title: "删除成功！！"
            });  
            this.getQuerySortList();//获得所有数据
            this.nextTick(function () {
                this.changeHotCity(this.formListData.hotCity);   
            })
            //
        }else{
            this.$Notice.error({
				title: resp.data.retmsg
			});
        }
      },
      async showAllRoom(){//显示所有房间modal
          this.$refs.houseListModal.resetFields()
          this.houseList.selected = [];
          this.houseList.selectedTemp = [];  

          this.houseList.isShow = true;
          this.houseList.curpage = 1;
          await this.getAllRoomData();
      },
     async getAllRoomData(){//获得所有房间
         //if(this.goOnce){
          this.houseList.loading = true;
          this.houseList.list = [];
          this.houseList.searchKey = '';
          let resp =  (await API.omsAPI[this.env].php.queryAllRoom(''));          
          resp && resp.data.forEach(item=>{
            item.queryString = item.chainName+item.roomName+item.title;
          })
          this.houseList.allData = resp.data;//暂存数据
          //this.houseDataTemp =    resp          
          this.houseList.count = resp.data.length;
          this.houseList.list = this.toCurPage(this.houseList.curpage,resp.data,this.houseList.pageSize);
          this.houseList.loading = false;//加载完毕
          //this.goOnce = false;
         //}         
      },
      changeSearchkey(){//关键词查询
          let arr = [];                        
          this.keyTemp.forEach((item)=>{        
              if(this.isContain(item.queryString,this.formListData.searchKey)){
                  arr.push(item);
              }                  
          })
          this.formListData.curpage = 1; 
          this.tempListData = arr;//赋值给当前数据源
          this.formListData.list = this.toCurPage(this.formListData.curpage,this.tempListData,this.formListData.pageSize);//显示当前页
          this.formListData.count = arr.length;//设置数据总数                   
      },
      houseSearch(){//搜索所有房间列表
          let arr = [];
            this.houseList.allData.forEach((item)=>{  
                if(item.title != null ){
                    if(this.isContain(item.queryString,this.houseList.searchKey)){    
                    arr.push(item);
                    } 
                }                   
            })
          //this.houseDataTemp = arr;  
          this.houseList.curpage = 1; 
          this.houseList.count = arr.length;//设置数据总数 
          this.houseList.searchShow = arr;
          //this.tempListData = arr;//赋值给当前数据源
          this.houseList.list = this.toCurPage(this.houseList.curpage,arr,this.houseList.pageSize);//显示当前页  
      },     
      async addSortByRoomIds(){//添加房间提交触发
        let obj = {};      
        let str = '';
        this.houseList.selected.push(...this.houseList.selectedTemp);//提交之前把当前页选中项push进来
        this.houseList.selected.forEach(item=>{
            str += item.roomId+',';
        });        
        str = str.slice(0,str.length-1);//去掉最后的逗号‘,’
        str= this.deleteRepetionChar(str).join();//数组转字符串        
        obj = {
            roomIds:str,
            sort: this.houseList.sort
        };
        if(obj.roomIds ==""){
          this.$Notice.error({
            title: "请选择房间！！"
              });
          this.houseList.addRoomLoading = false;
            //this.houseList.isShow = true;
          return;
        }   
        let validResult = true;
        this.$refs.houseListModal.validate(valid => {
            validResult = valid
        });
        if (!validResult) {
            this.houseList.addRoomLoading = false;
            return;
        } 
        let resp =  (await API.omsAPI[this.env].php.addSortByRoomIds(obj)).data;         
        if(resp.retcode == 1){
          this.$Notice.success({
            title: "关联成功！！"
          });
          this.houseList.isShow = false;  
          this.getQuerySortList();//获得所有数据
            
        }else{
          this.$Notice.error({
            title: resp.retmsg
          });
          this.houseList.isShow = false;
        } 
        this.houseList.selected = [];//提交完以后清空缓存      
        this.houseList.selectedTemp = [];   
        this.$refs.houseTable.selectAll(false);//取消选中   
      },
     deleteRepetionChar(arr){//去除重复选择的项
        if( typeof arr == "object"){
             //arr = arr;
        }else if( typeof arr == "string"){
             arr = arr.split(",")
        }
        let box = [];//存放去重数据
        let thisArr;//当前的值arr[i]
        for (let i = 0; i < arr.length; i++) {
            thisArr = arr[i];
            let flag = true;
            for (var j = 0; j < box.length; j++) {
                if(box[j]==thisArr){
                    flag = false;
                    break;//结束for循环
                }
            }
            if(flag==false){
                continue ;
            }
            box.push(thisArr);
        }
        return box
    },
      houseChangePageSize(pageSize){//全部房间列表改变pagesize
        let arr = [];
        this.houseList.selected.push(...this.houseList.selectedTemp);//改变页码之前转移存储
        this.houseList.pageSize = pageSize;
        arr = (this.houseList.searchKey =='')? this.houseList.allData:this.houseList.searchShow;
        this.houseList.list = this.toCurPage(this.houseList.curpage,arr,this.houseList.pageSize);
        this.setDefault(arr,this.houseList.selected);//设置默认选中
      },
      houseChangePage(page){//房间列表改变页码
        let arr = []; 
        this.houseList.selected.push(...this.houseList.selectedTemp);//翻页之前转移存储        
        this.houseList.curpage = page;
        arr = (this.houseList.searchKey =='')? this.houseList.allData:this.houseList.searchShow;
        //this.houseList.allData
        this.houseList.list = this.toCurPage(this.houseList.curpage,arr,this.houseList.pageSize);
        this.setDefault(arr,this.houseList.selected);//设置默认选中
      },
      selectionChange(selection){//选中项改变
          this.houseList.selectedTemp = selection;     
          this.houseList.addRoomLoading = true;  
              
      },
      allSelect(selection){
        console.info(selection);
         
      },
      selectOne(selection,row){
        console.info(selection+row);
         
      },
      setDefault(arr,selected){
          for(let i = 0;i<arr.length;i++){
            for(let j = 0;j<selected.length; j++){
                if(arr[i].roomId == selected[j].roomId){                    
                    arr[i]._checked = true;//默认选中
                }
            }
        }
      }
    },
    async mounted(){      
      this.getQuerySortList();//获得所有数据
      this.queryRoomTagByCname();//获得热门城市
      //this.queryAllRoom();
    },
    data(){
      return {
        houseList:{
            addRoomLoading:true,
            loading:true,
            isShow:false,
            pageSize:10,
            count:0,
            curpage:1,
            list:[],
            allData:[],
            selected:[],
            sort:'1',
            selectedTemp:[],
            searchShow:[],
            columns:[
            {
                type: "selection",
                align: "center",
                width: 60
            },
            {
                title: "门店名称",
                key: "chainName",
                align: "center",
                width: 150

            },
            {
                title: "房间名称",
                key: "roomName",
                align: "center",
                width: 250
            },
            {
                title: "房间标题",
                key: "title",
                align: "center",
                width: 250
            }
            ]
        },
        weight:{
            isShow:false,
            sort:'',
            roomId:'',
            custRoomNo: '',
            custRoomName:''             
        },
        title:"房间排序",
        formListData:{
            loading:false,
            list:[],
            pageSize:10,
            curpage:1,
            count:0,
            hotCity:'全部',
            hotCitys:[],
            searchKey:''            
        },
        column:[
            {
                title: "房间id",
                key: "roomId",
                align: "center",
                width: 150,
                count:0 
            },
            {
                title: "城市",
                key: "city",
                align: "center",
                width: 150 
            },
            {
                title: "房间名",
                key: "custRoomNo",
                align: "center",
                width: 300 
            },
            {
                title: "房间标题",
                key: "custRoomName",
                align: "center",
                width: 450 
            },
            {
                title: "房间类型",
                key: "roomTypeName",
                align: "center",
                width: 150 
            },
            {
                title: "排序权重",
                key: "sort",
                align: "center",
                sortable:true,
                width: 200 
            },
            {
                title: "操作",                
                align: "center",
                width: 200,
                render: (h,params) => 
                    {
                        return h("div",
                            [
                              h('Button',{
                                  props: {
                                        type: 'primary',
                                        size: 'default'
                                    },
                                  on:{
                                      click:()=>{
                                        this.dataIndex = params.index;//操作的数据当前的索引值	
                                        this.weight.isShow = true;//显示权重修改modal
                                        this.weight.roomId = params.row.roomId;//赋值房间id
                                        this.weight.sort = params.row.sort;//赋值默认权重
                                        this.weight.custRoomNo = params.row.custRoomNo;//房间标题
                                        this.weight.custRoomName = params.row.custRoomName;//房间名                                  																							
                                        }
                                      }
                                },"修改"),
                                h('Button',{                                   
                                    props: {
                                        type: 'error',
                                        size: 'default'
                                    },
                                    style:{
                                        "marginLeft":"10px"
                                    },
                                    on:{
                                        click:()=>{
                                            this.delRoom(params.row.roomId,params.index);                                                                                																							
                                            }
                                        }
                                },"删除")
                          ]);
                    } 
            }
        ],
        houseListRules: {
            sort: [
                {required: true, message:'请填写排序权重', trigger: 'blur'}
            ]
        }
      }
    }
}
</script>
<style scope>
.text-tips{ 
  color: red; 
  margin-left:20px; 
  font-size: 18px; 
  line-height: 18px;
  margin-bottom: 24px;
  display: inline-block;
}
</style>





// WEBPACK FOOTER //
// src/pages/advert/roomSort.vue